<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">EDITORIAL BOARD</h1>
            </div>
        </div>

        <div class="editorial_board">
            <div class="container mb-12">
                <Breadcrumbs :breadcrumbs="[
                    { label: 'Home', href: '/' },
                    { label: 'Editorial Board', href: '/editoral-board-test' }
                ]" class="mb-4 pt-4 pb-2" />


                <!-- <div class="category_div">

                    <div class="row mb-6" v-for="data in editoralboard">
                        <div class="heading"  v-for="data1 in data.sdjsjfkdk">
                            <h2>{{ data1.name }}</h2>
                        </div>
                        
                    </div>
                </div> -->

                <div class="category_div" v-for="data in editoralboard">
                    <div class="heading">
                        <h2>{{data.name}}</h2>
                    </div>
                    <div class="row mb-6">
                        <div class="col-4 mb-3 d-flex" v-for="data1 in data.editorial">                             
                            <div class="text-sm mb-6 md:mb-0 col-full md:col-1/3 lg:col-1/4 ">
                                <div :class="{'flex justify-center items-center bg-gray-300 h-64': !data1.portrait}"  class="img_box max-w-full text-center">
                                    <img v-if="data1.portrait" :alt="data1.name" :src="`/media/${data1.portrait.uuid}`">
                                    <font-awesome-icon v-else icon="user-md" size="5x"/>
                                </div>
                            </div>
                            <div class="text-sm col-full md:col-2/3 lg:col-3/4 space-y-4 content_div">
                                <b>{{data1.title}}</b>                            
                                <b>{{ data1.designation }}</b>
                                <p>{{data1.name}}</p>
                                <p>{{data1.description}}</p>                    
                            </div>
                        </div>                   
                    </div>
                </div>



            </div>
        </div>
    </div>
</template>

<script>
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import PostsList from "@app/Shared/Components/PostsList";

export default {

    mixins: [HasMetaData],

    props: {
        editoralboard: [],
        // editorialBoards: [],
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        PostsList
    },
};
</script>
